import {
  Rentability,
  RentabilityType
} from '@/modules/settings/tasa/types/types.ts'

export const sortDesc = (a: Rentability, b: Rentability) =>
  Number(b.quotes) - Number(a.quotes)

export const processRentabilities = (
  rentabilities: Rentability[],
  levelRentabilityId?: string,
  promoRentabilityId?: string,
  rentabilityType?: RentabilityType
) => {
  let sortedRentabilities: Rentability[] | null = null
  let promoRentability: null | Rentability = null

  if (promoRentabilityId) {
    promoRentability =
      rentabilities.find((r) => String(r.id) === String(promoRentabilityId)) ||
      null
    if (!promoRentability && rentabilityType !== 'MOTO')
      throw new Error('No rentability coincides with given promoRentability id')
  }
  if (rentabilityType === 'MOTO') {
    sortedRentabilities = rentabilities?.filter((r) => {
      return String(r.id) !== String(promoRentabilityId)
    })
  } else if (levelRentabilityId) {
    const levelRentability = rentabilities.find(
      (r) => String(r.id) === String(levelRentabilityId)
    )

    if (!levelRentability)
      throw new Error('No rentability coincides with given levelRentability id')

    const filterOut = (r: Rentability) => {
      if (String(r.id) === String(promoRentabilityId)) return false
      return Number(r.quotes) <= Number(levelRentability.quotes)
    }
    sortedRentabilities = rentabilities?.filter(filterOut)
  }

  sortedRentabilities = sortedRentabilities
    ? sortedRentabilities.sort(sortDesc)
    : rentabilities.sort(sortDesc)

  return promoRentability
    ? [promoRentability, ...sortedRentabilities]
    : sortedRentabilities
}
